<div class="container-xxl gx-0 gx-sm-9 gx-lg-10 gx-xxl-0">
    <div class="g-0 align-items-center">
        <div class="font-primary px-4 px-md-0 pe-md-4 pe-lg-14">
            <h1 class="mt-10 mt-md-5 fs-md-39 fs-29 fw-700 mb-5">{{ 'CERTIFICATES.title' | translate }}</h1>
            <p class="fs-16 lh-29 mb-5" [innerHtml]="'CERTIFICATES.sub-title' | translate"></p>
            <p class="fs-16 mb-3" [innerHtml]="'CERTIFICATES.description.1' | translate"></p>
            <p class="fs-16 mb-3" [innerHtml]="'CERTIFICATES.description.2' | translate"></p>
            <p class="fs-16 mb-3" [innerHtml]="'CERTIFICATES.description.3' | translate"></p>
        </div>
        <div class="font-primary px-4 px-md-0 pe-md-4 pe-lg-14 mb-5">
            <p class="fs-16 mb-3" [innerHtml]="'CERTIFICATES.list-text' | translate"></p>
            <ul>
                <li>
                    <a
                        [href]="
                            currentLang === 'pl'
                                ? '../../../../assets/certificates/PolitykaOdpowiedzialnegoBiznesu.pdf'
                                : '../../../../assets/certificates/ResponsibleBusinessPolicy.pdf'
                        "
                        class="fs-16"
                        [innerHtml]="'CERTIFICATES.list-line.1' | translate"
                        download
                    ></a>
                </li>
                <li>
                    <a
                        [href]="
                            currentLang === 'pl'
                                ? '../../../../assets/certificates/PolitykaLancuchaDostaw.pdf'
                                : '../../../../assets/certificates/SupplyChainPolicy.pdf'
                        "
                        class="fs-16"
                        [innerHtml]="'CERTIFICATES.list-line.2' | translate"
                        download
                    ></a>
                </li>
                <li>
                    <a
                        [href]="
                            currentLang === 'pl'
                                ? '../../../../assets/certificates/PolitykaDotyczacaPrawCzlowiekaIWarunkowPracy.pdf'
                                : '../../../../assets/certificates/HumanRightsAndWorkingConditionsPolicy.pdf'
                        "
                        class="fs-16"
                        [innerHtml]="'CERTIFICATES.list-line.3' | translate"
                        download
                    ></a>
                </li>
                <li>
                    <a
                        [href]="
                            currentLang === 'pl'
                                ? '../../../../assets/certificates/PolitykaPrzeciwdzialaniuPraniuPieniedzyIfinansowaniuTerroryzmu.pdf'
                                : '../../../../assets/certificates/Anti-MoneyLaunderingAndTerrorismFinancingPolicy.pdf'
                        "
                        class="fs-16"
                        [innerHtml]="'CERTIFICATES.list-line.4' | translate"
                        download
                    ></a>
                </li>
                <li>
                    <a
                        [href]="
                            currentLang === 'pl'
                                ? '../../../../assets/certificates/PolitykaDotyczacaSrodowiskaNaturalnego.pdf'
                                : '../../../../assets/certificates/EnvironmentalPolicy.pdf'
                        "
                        class="fs-16"
                        [innerHtml]="'CERTIFICATES.list-line.5' | translate"
                        download
                    ></a>
                </li>
                <li>
                    <a
                        [href]="
                            currentLang === 'pl'
                                ? '../../../../assets/certificates/PolitykaPoufnosci.pdf'
                                : '../../../../assets/certificates/ConfidentialityPolicy.pdf'
                        "
                        class="fs-16"
                        [innerHtml]="'CERTIFICATES.list-line.6' | translate"
                        download
                    ></a>
                </li>
                <li>
                    <a
                        [href]="
                            currentLang === 'pl'
                                ? '../../../../assets/certificates/PolitykaBhp.pdf'
                                : '../../../../assets/certificates/WorkplaceHealthAndSafetyPolicy.pdf'
                        "
                        class="fs-16"
                        [innerHtml]="'CERTIFICATES.list-line.7' | translate"
                        download
                    ></a>
                </li>

                <li>
                    <a
                        [href]="
                            currentLang === 'pl'
                                ? '../../../../assets/certificates/PolitykaPostepowaniaZSubstancjamiNiebezpiecznymi.pdf'
                                : '../../../../assets/certificates/HazardousSubstanceHandlingPolicy.pdf'
                        "
                        class="fs-16"
                        [innerHtml]="'CERTIFICATES.list-line.8' | translate"
                        download
                    ></a>
                </li>
            </ul>
        </div>
    </div>
</div>
